// localStorage can be missing (null), or throw a SecurityError on access, in
// Safari private mode, some in-app WebViews and browsers with site data
// blocked. These helpers never throw so storage can't crash a render.

let localStorageAvailable: boolean | null = null;

export function isLocalStorageAvailable(): boolean {
  if (localStorageAvailable !== null) {
    return localStorageAvailable;
  }
  // If we haven't determined its availability yet, try to set, get, and remove
  // a record. If we can do so, and the output matches the input, we can assume
  // we have it available.
  try {
    localStorage.setItem('_', '_');
    const result = localStorage.getItem('_');
    localStorage.removeItem('_');
    localStorageAvailable = result === '_';
  } catch (e) {
    localStorageAvailable = false;
  }
  return localStorageAvailable;
}

export function safeGetItem(key: string): string | null {
  if (!isLocalStorageAvailable()) return null;
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

export function safeSetItem(key: string, value: string): void {
  if (!isLocalStorageAvailable()) return;
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    // Quota exceeded or storage revoked mid-session; nothing to do.
  }
}

// Test-only: clear the cached availability check.
export function resetLocalStorageAvailability(): void {
  localStorageAvailable = null;
}
